import { IPositioningFlight, IFlight } from "@vmosolutions/oc-interfaces";
import { getFlightById } from "src/redux/actions/flights/FlightData.Actions";
import { v1 } from "uuid";

/**
 * Takes a flight and converts it into a positioning flight.
 * @param flight - IFlight
 * @returns - IPositioningFlight
 */
export const convertFlightToPosFlight = (flight: IFlight, iataCode?: string): IPositioningFlight => {
  const { _id, origin, destination, actualOut, actualIn, flightNumber, aircraft } = flight;
  return {
    flight_id: _id, // populate the flight_id field with the current flight's id.
    flightNumber: flightNumber,
    origin: origin,
    destination: destination,
    outTime: actualOut,
    inTime: actualIn,
    airlineIATA: iataCode ?? undefined,
    bookings: [],
    isGround: false,
    createdAt: undefined,
    createdBy: undefined,
    _tempId: `temp-${v1()}`,
    aircraft: {
      registration: aircraft?.registration,
      aircraftType: { title: aircraft?.aircraftType?.title },
    },
  };
};

/**
 * Takes a positioning flight and converts it into a flight.
 * @param posFlight - IPositioningFlight
 * @returns - IFlight
 */
export const convertPosFlightToFlight = async (posFlight: IPositioningFlight): Promise<IFlight | null> => {
  const { flight_id } = posFlight;
  const flight = await getFlightById(flight_id);
  return flight?._id ? flight : null;
};
